module.exports = __webpack_public_path__ + "static/media/dualCam.12fa36a0.svg";